import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 448 522",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M326.064 0c8.62 74.074 49.997 118.237 121.936 122.935v83.314c-41.69 4.072-78.209-9.553-120.683-35.236v155.822c0 197.949-215.974 259.808-302.803 117.923-55.796-91.3-21.629-251.507 157.358-257.928v87.855c-13.636 2.193-28.212 5.638-41.534 10.18-39.81 13.468-62.379 38.681-56.11 83.157 12.069 85.193 168.486 110.407 155.477-56.065V.157h86.359V0z",
      stroke: "none"
    })]
  });
};
const IconTiktok = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Tiktok__IconTiktok",
  componentId: "sc-utxaaz-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconTiktok };
